export const defaultProfile = {
  ownerId: '',
  visibility: 'public',
  displayName: 'Your Name',
  username: 'your-story',
  usernameLower: 'your-story',
  tagline: 'A living autobiography, shaped one memory at a time.',
  bio: 'Start with a short introduction. Keep it public, private, or somewhere in between.',
  theme: {
    template: 'memoir',
    accentColor: '#8a5a34',
    colorScheme: 'paper',
    fontPairing: 'serif-sans',
    backgroundStyle: 'plain',
    cardStyle: 'soft',
  },
  sections: [
    { id: 'hero', title: 'Opening Page', type: 'hero', visibility: 'public' },
    { id: 'timeline', title: 'Timeline', type: 'timeline', visibility: 'public' },
    { id: 'stories', title: 'Stories', type: 'stories', visibility: 'public' },
    { id: 'widgets', title: 'Widgets', type: 'widgets', visibility: 'public' },
    {
      id: 'private-notes',
      title: 'Private Notes',
      type: 'custom',
      visibility: 'private',
      content: 'A private space for notes that are not ready for the public profile.',
      locked: false,
    },
  ],
};

export const lockedSectionTypes = ['hero', 'timeline', 'stories', 'widgets'];

function cloneDefaultProfile() {
  return {
    ...defaultProfile,
    theme: { ...defaultProfile.theme },
    sections: defaultProfile.sections.map((section) => ({ ...section })),
  };
}

export function normalizeProfile(profile = {}) {
  const base = cloneDefaultProfile();
  const incomingSections = Array.isArray(profile.sections) ? profile.sections : [];
  const mergedSections = incomingSections.map((section) => ({
    id: section.id,
    title: section.title || 'Untitled Section',
    type: section.type || 'custom',
    visibility: section.visibility || 'private',
    content: section.content || '',
    locked: lockedSectionTypes.includes(section.type),
  }));

  base.sections.forEach((section) => {
    if (!mergedSections.some((existing) => existing.id === section.id || existing.type === section.type)) {
      mergedSections.push({ ...section, locked: lockedSectionTypes.includes(section.type) });
    }
  });

  return {
    ...base,
    ...profile,
    theme: { ...base.theme, ...(profile.theme || {}) },
    sections: mergedSections,
  };
}

export function normalizeUsername(value) {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 32);
}

export function usernameFromEmail(email) {
  const [name] = email.split('@');
  return normalizeUsername(name || 'your-story') || 'your-story';
}

export function buildDefaultProfile(user, overrides = {}) {
  const username = normalizeUsername(overrides.username || usernameFromEmail(user.email || ''));
  return {
    ...cloneDefaultProfile(),
    ownerId: user.uid,
    displayName: overrides.displayName || user.displayName || defaultProfile.displayName,
    username,
    usernameLower: username,
    email: user.email || '',
    createdAt: null,
    updatedAt: null,
  };
}

export function createCustomSection() {
  return {
    id: `custom-${Date.now()}`,
    title: 'New Section',
    type: 'custom',
    visibility: 'private',
    content: 'Write something personal here, then choose if it belongs on the public profile.',
    locked: false,
  };
}
